import { USERNAME_AUTH_DOMAIN } from "@libs/api/constants";
import { usernameSchema } from "@/domain/auth";

export const getUsernameAuthEmail = (username: string) =>
  `${usernameSchema.parse(username)}@${USERNAME_AUTH_DOMAIN}`;

export const checkIsUsernameAuthEmail = (email: string | null | undefined) =>
  Boolean(email?.toLowerCase().endsWith(`@${USERNAME_AUTH_DOMAIN}`));
